module.exports = __webpack_public_path__ + "static/media/chair-5.2c5175b9.png";